import { CircularProgress, Backdrop } from "material-ui"
import React from "react"

export default function Gallery({
    onChange,
    inputRootRef,
    gallery,
    handleDelete,
    makeDefaultGallery,
    showDelete,
    submitDelete,
    closeDelete,
    isGalleryLoading
}) {

    return (
        <div className="gallery_root" ref={inputRootRef}>
            <Backdrop
                style={{ color: '#fff', zIndex: isGalleryLoading ? 1000 : -1000 }}
                open={isGalleryLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className={`showDelete ${showDelete ? 'active' : ''}`} onClick={closeDelete}>
                <div onClick={e => e.stopPropagation()}>
                    <span onClick={closeDelete}>×</span>
                    <p>Are you sure you want to delete gallery image?</p>
                    <div>
                        <a className='button' onClick={submitDelete}>Delete</a>
                        <a className='button' onClick={closeDelete}>Cancel</a>
                    </div>
                </div>
            </div>
            <input onChange={onChange} id='gallery' type='file' accept='image/*' multiple style={{ display: 'none' }} />
            <label htmlFor='gallery' className="gallery">
                Drop files here or click
            </label>
            <div className='gallery_list'>
                {gallery.map(item => <div key={item.id} className='gallery_item'>
                    <div className='gallery_menu'>
                        <div className={`default ${item.is_default ? 'active' : ''}`} onClick={() => makeDefaultGallery(item.id)} />
                        <div className='delete' onClick={() => handleDelete(item.id)}>×</div>
                    </div>
                    <img src={item.image_url} alt='' />
                </div>)}
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.jsx